import React from 'react';
import {Navigate} from "react-router-dom";
import {Box, CircularProgress} from "@mui/material";
import {useUserAuth} from "./UserAuthContext";

/**
 * Guarda uma rota por papel.
 * Ex.: <RoleRoute roles={["association"]}>...</RoleRoute>
 *
 * - Não logado            -> redireciona para a página inicial (/
 *                            onde há os botões Entrar/Registar)
 * - Email não verificado  -> redireciona para /login (a vista explica)
 * - Conta não ativada     -> redireciona para /login (a vista explica)
 *                            (associação OU engenheiro, igual às apps)
 * - Papel não permitido   -> redireciona para /
 * - Papel permitido       -> mostra a página
 */
const RoleRoute = ({roles = ["association"], children}) => {

    const {user, role, profile, roleLoading, authLoading} = useUserAuth();

    if (authLoading || roleLoading) {
        return (
            <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", height: "40vh"}}>
                <CircularProgress />
            </Box>
        );
    }

    if (!user) {
        // Sem sessão (ex.: após "Sair"): volta à página inicial, que tem
        // os botões Entrar/Registar. (Utilizadores logados em estado de
        // "porta" continuam a ir para /login, onde a vista explica o estado.)
        return <Navigate to="/" replace/>;
    }

    // Regras iguais às das apps: email verificado + conta ativada.
    // (Admin fica de fora: é identificado só pelo email e a conta de admin
    //  nunca passou pelo fluxo de verificação — e continua a ir para /dashboard.)
    if (user.emailVerified === false && role !== "admin") {
        return <Navigate to="/login" replace/>;
    }

    // Associação ou engenheiro com a conta desativada: fica na vista de
    // "à espera de ativação" (mesma regra das apps: Enabled=false).
    if ((role === "association" || role === "engineer") && profile && profile.Enabled === false) {
        return <Navigate to="/login" replace/>;
    }

    if (!roles.includes(role)) {
        return <Navigate to="/" replace/>;
    }

    return children;
};

export default RoleRoute;
